<script setup>
import { useI18n } from 'vue-i18n';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

const companyDetails = computed(() => usePage().props.company_details);
const options = computed(() => usePage().props.template_options);
</script>

<template>
    <div>
        <p
            v-if="options.footer.opening_hours_footer_title && companyDetails.opening_hours"
            class="mb-4 mt-8 text-xl font-black md:mt-0 md:text-3xl"
        >
            {{ options.footer.opening_hours_footer_title }}
        </p>

        <div
            v-if="companyDetails.opening_hours"
            v-html="companyDetails.opening_hours"
        />
    </div>
</template>
